<template>
  <b-modal
    id="payment-update-link"
    centered
    hide-footer
    hide-header
    size="md"
    :visible="true"
    @hide="$emit('close')"
  >
    <div class="payment-update-link">
      <div class="payment-update-link__icon">
        <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round">
          <rect x="2" y="4" width="20" height="16" rx="2"/>
          <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"/>
        </svg>
      </div>
      <p class="payment-update-link__lead">Check your email</p>
      <p class="payment-update-link__text">
        Shopify will send a secure link to <strong>{{ email || 'your email on file' }}</strong> to update your payment method.
      </p>
      <b-button class="no-outline-btn payment-update-link__btn" variant="primary" block @click="$emit('close')">
        Got it
      </b-button>
    </div>
  </b-modal>
</template>

<script>
export default {
  name: 'PaymentUpdateLinkPopup',
  props: {
    email: String
  }
}
</script>

<style scoped>
.payment-update-link {
  text-align: center;
  padding: 0.5rem 0.5rem 0.25rem;
}

.payment-update-link__icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 64px;
  height: 64px;
  margin-bottom: 1rem;
  border-radius: 50%;
  color: var(--theme_color, #8bc31f);
  background-color: rgba(139, 195, 31, 0.12);
}

.payment-update-link__lead {
  margin-bottom: 0.5rem;
  font-size: 1.25rem;
  font-weight: 600;
  color: #333333;
}

.payment-update-link__text {
  margin-bottom: 1.5rem;
  color: #787878;
  line-height: 1.5;
}

.payment-update-link__btn {
  margin: 0 auto;
  max-width: 320px;
}
</style>
